import { render } from "./CourseGroupAdd.vue?vue&type=template&id=ed5409e8"
import script from "./CourseGroupAdd.vue?vue&type=script&lang=js"
export * from "./CourseGroupAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__